import React from 'react';
import { mainNav } from '../../data/data';

interface MobileMenuProps {
    isMobileMenuOpen: boolean;
    setIsMobileMenuOpen: (b: boolean) => void
}

const MobileMenu: React.FC<MobileMenuProps> = ({ isMobileMenuOpen, setIsMobileMenuOpen }) => {

  return (
    isMobileMenuOpen && mainNav.length && (
        <div id="mobile-menu" className="md:hidden mt-4 pb-4 border-t border-blue-800" aria-label="Mobile navigation menu">
          <div className="flex flex-col space-y-2 pt-4">
            {mainNav.map(({title, target}) => (
                <a
              href={`#${target}`}
              className="block px-3 py-2 rounded-md hover:bg-blue-800 transition-colors focus:outline-none focus:ring-2 focus:ring-blue-300"
              onClick={() => setIsMobileMenuOpen(false)}
              aria-label={`Navigate to ${title} section`}
            >
              {title}
            </a>
            ))}
          </div>
        </div>
      )
  );
};

export default MobileMenu;
